import { motion } from "framer-motion";
import { CheckCircle2, XCircle, Clock, Phone, Wifi, Zap, ShieldPlus, Gamepad2, Wallet, Droplets, ArrowLeftRight, ReceiptText } from "lucide-react";
import { formatIDR, formatDate } from "../lib/api";

const TYPE_ICONS = {
    pulsa: Phone, data: Wifi, pln_token: Zap, pln_bill: ReceiptText,
    bpjs: ShieldPlus, game: Gamepad2, ewallet: Wallet, pdam: Droplets, transfer: ArrowLeftRight,
};

const TYPE_LABELS = {
    pulsa: "Pulsa", data: "Paket Data", pln_token: "Token PLN", pln_bill: "Tagihan PLN",
    bpjs: "BPJS", game: "Voucher Game", ewallet: "E-Wallet", pdam: "PDAM", transfer: "Transfer",
};

export default function TransactionItem({ tx, onClick, index = 0 }) {
    const type = String(tx.type || "").toLowerCase();
    const Icon = TYPE_ICONS[type] || ReceiptText;
    const statusConfig = {
        success: { icon: CheckCircle2, color: "text-emerald-500 bg-emerald-500/10", label: "Sukses" },
        failed: { icon: XCircle, color: "text-rose-500 bg-rose-500/10", label: "Gagal" },
        pending: { icon: Clock, color: "text-amber-500 bg-amber-500/10", label: "Pending" },
        processing: { icon: Clock, color: "text-amber-500 bg-amber-500/10", label: "Diproses" },
        refunded: { icon: CheckCircle2, color: "text-sky-500 bg-sky-500/10", label: "Dikembalikan" },
        cancelled: { icon: XCircle, color: "text-muted-foreground bg-muted", label: "Dibatalkan" },
    }[String(tx.status).toLowerCase()] || { icon: Clock, color: "text-muted-foreground bg-muted", label: tx.status };
    const StatusIcon = statusConfig.icon;

    return (
        <motion.button
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.02 }}
            onClick={onClick}
            data-testid={`tx-item-${tx.id}`}
            className="w-full flex items-center gap-3 p-3 rounded-2xl bg-card border border-border hover:border-brand-green/40 hover:shadow-md transition text-left"
        >
            <div className="h-11 w-11 rounded-xl bg-secondary flex items-center justify-center flex-shrink-0">
                <Icon className="h-5 w-5 text-brand-deep dark:text-brand-green" />
            </div>
            <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                    <div className="font-semibold text-sm truncate">{tx.product?.name || tx.product_name || tx.productCode}</div>
                    <div className="font-heading font-bold text-sm whitespace-nowrap">{formatIDR(tx.sellPrice ?? tx.totalAmount ?? tx.total)}</div>
                </div>
                <div className="flex items-center justify-between gap-2 mt-1">
                    <div className="text-xs text-muted-foreground truncate">
                        {TYPE_LABELS[type] || (type === "pln" ? "PLN" : "Produk")} · {tx.targetNumber || tx.customer_number}
                    </div>
                    <div className={`text-[10px] font-medium px-2 py-0.5 rounded-full flex items-center gap-1 ${statusConfig.color}`}>
                        <StatusIcon className="h-3 w-3" />
                        {statusConfig.label}
                    </div>
                </div>
                <div className="text-[10px] text-muted-foreground mt-1">{formatDate(tx.createdAt || tx.created_at)}</div>
            </div>
        </motion.button>
    );
}
